import type { SearchCriteriaParams, TouristGroupRoom } from '@/shared/model';
import { isInfant, isKid } from '../config/tourists';
import type { TouristRoom } from '../model/types';

type TouristGroup = SearchCriteriaParams['touristGroup'];

function toGroupRoom(room: TouristRoom | undefined): TouristGroupRoom {
  const ages = room?.childrenAges ?? [];

  return {
    adults: room?.adults || 0,
    kids: ages.filter((age) => isKid(age)).length,
    infants: ages.filter((age) => isInfant(age)).length,
    ages,
  };
}

export function toTouristGroup(rooms: TouristRoom[] = []): TouristGroup {
  const [first, ...rest] = rooms;
  const group: TouristGroup = toGroupRoom(first);

  if (rest.length) {
    group.touristsByRooms = rest.map((room) => toGroupRoom(room));
  }

  return group;
}

export function toTouristRooms(group: TouristGroup): TouristRoom[] {
  return [group, ...(group.touristsByRooms ?? [])].map((room) => ({
    adults: room.adults,
    childrenAges: room.ages ?? [],
  }));
}

export function countTourists(group: TouristGroup): number {
  return [group, ...(group.touristsByRooms ?? [])].reduce(
    (total, room) => total + room.adults + room.kids + room.infants,
    0,
  );
}
